import { axiosSecuredInstance } from "configurations/axiosConfig";

// Shape returned by GET /api/PolicyInformationTransaction/GetPolicyTransactionCount.
// Mirrors `Stewart.Shared.Entities.PolicyData.PolicyTransactionCount` 1:1.
// Wire format is PascalCase because the Web.React project sets
// `JsonSerializerOptions.PropertyNamingPolicy = null` in Startup.cs.
export type PolicyTransactionCountDto = {
  QualityReviewCount: number;
  PreCloseCount: number;
  CloseCount: number;
  HistoryCount: number;
  HoldCount: number;
  TotalCount: number;

  QualityReviewErrorCount: number;
  QualityReviewHoldCount: number;
  QualityReviewLockedCount: number;
  QualityReviewEditCount: number;
  QualityReviewUneditCount: number;

  PreClosePassedCount: number;
  PreCloseForcePromotedCount: number;
  PreCloseHoldCount: number;
  PreCloseLockedCount: number;
  PreCloseEditCount: number;
  PreCloseUneditCount: number;
  PreCloseAdjCount: number;

  CloseForcePromotedCount: number;
  CloseEditCount: number;
  CloseUneditCount: number;

  HistoryAdjCount: number;
  HistoryEditCount: number;
  HistoryUneditCount: number;
};

/**
 * Fetches the Policy Management tab/chip counts for the given page-level
 * filter state. Pass `undefined` (NOT empty string) when a filter is unset —
 * axios drops `undefined` query params, which makes the .NET model binder
 * bind to `null`. The stored procedure expects `NULL` for the "all" case.
 */
export const getPolicyTransactionCount = async (
  agencyType: string | undefined,
  stateCodeList: string | undefined
): Promise<PolicyTransactionCountDto | null> => {
  try {
    const { data } = await axiosSecuredInstance.get<PolicyTransactionCountDto>(
      "/PolicyTransaction/GetPolicyTransactionCount",
      { params: { agencyType, stateCodeList } }
    );
    return data ?? null;
  } catch (error) {
    console.error("getPolicyTransactionCount failed", error);
    return null;
  }
};

// Shape returned by GET /api/PolicyInformationHistory/GetPolicyHistoryCount.
// PascalCase wire format (see PolicyTransactionCountDto note above).
export type PolicyHistoryCountDto = {
  TotalCount: number;
  SimultaneousCount: number;
  AdjCount: number;
  EditCount: number;
  UneditCount: number;
};

export const getPolicyHistoryCount =
  async (): Promise<PolicyHistoryCountDto | null> => {
    try {
      const { data } = await axiosSecuredInstance.get<PolicyHistoryCountDto>(
        "/PolicyHistory/GetPolicyHistoryCount"
      );
      return data ?? null;
    } catch (error) {
      console.error("getPolicyHistoryCount failed", error);
      return null;
    }
  };
